module.exports = __webpack_public_path__ + "static/img/fortune_tiger.fb81cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gift/specific/fortune_tiger.png
// module id = 7Kbe
// module chunks = 1